import { SvgIcon, SxProps } from "@mui/material";
import { ReactElement } from "react";

import { palette } from "~frontend/theme";

export default ({ sx = {} }: { sx?: SxProps }): ReactElement => (
  <SvgIcon sx={sx || {}}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
    >
      <circle
        cx="4"
        cy="4"
        r="4"
        fill={(sx && "color" in sx && (sx.color as string)) || palette.red}
      />
      <circle cx="4.0002" cy="3.99995" r="0.8" fill="white" />
    </svg>
  </SvgIcon>
);
